import React from 'react';
import { Link } from 'gatsby';

import { Root, Layout, Menu, Logo, Company, Address, Tel, Fax, Copyright } from './index.styled';
import logoImage from './assets/logo-image.gif';

const HEIGHT = '80px';

const Footer = () => {
  return (
    <Root>
      <Layout height={HEIGHT}>
        <Menu>
          <ul>
            <li><Link to="/">HOME</Link></li>
            <li><Link to="/molded-piece">成形品</Link></li>
            <li><Link to="/equipment">設備</Link></li>
            <li><Link to="/company">会社概要</Link></li>
            <li><Link to="/access">アクセス</Link></li>
            <li><Link to="/contact">お問い合わせ</Link></li>
          </ul>
        </Menu>
        <Logo>
          <img src={logoImage} alt="精密プラスチック射出成形｜株式会社野中製作所" />
        </Logo>
        <Company>株式会社野中製作所</Company>
        <Address>〒577-0016　大阪府東大阪市長田西5丁目1番15号</Address>
        <Tel>TEL：06-6747-1118（代）</Tel>
        <Fax>FAX：06-6747-1188</Fax>
        <Copyright>Copyright &copy; NONAKA SS CO.,LTD.</Copyright>
      </Layout>
    </Root>
  );
};

export default Footer;
export {HEIGHT};